import BaseProxy from "../../base-proxy";

/**
 * @class GetInvoicesProxy
 * @description Class used for communicating GET requests with invoices API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since December 06, 2018
 */
export default class GetInvoicesProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.id - Company id.
   * @param {String} input.skippedEntries - Skipped entries.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async execute(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${input.id}/paginated-invoices?skip=${input.skippedEntries}/`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getCompanyInvoices(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${input.id}/invoices`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getCompanyInvoice(data, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${data.id}/invoice?invoice_tag=${input.invoice_tag}&status=${input.status}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, data.authToken);
  }
}
